import InsightAdGroup from "../../../../components/AssetManagement/Overview/Insights/InsightAdgroupandCampaign/InsightAdgroup"


const InsightAdgroupScreen = () => {
  return (
    <div>
       <InsightAdGroup />
    </div>
  )
}

export default InsightAdgroupScreen